var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { observer } from "mobx-react";
import * as RenderMethods from "./RenderMethods";
let AggregateCard = class AggregateCard extends React.Component {
    constructor(props) {
        super(props);
        this.renderEventsCount = RenderMethods.renderEventsCount;
        this.renderCardDetails = RenderMethods.renderCardDetails;
        this.renderArrow = RenderMethods.renderArrow;
        this.componentPrefix = "aggregate-card";
    }
    render() {
        return (React.createElement("div", { className: `rj-ev-list__${this.componentPrefix}`, "data-uat": `div-ev-list-${this.componentPrefix}` },
            React.createElement("a", { className: `rj-ev-list__${this.componentPrefix}__link`, href: this.props.event.linkUrl, onClick: this.props.handler, key: `${this.componentPrefix}__link__${this.props.event.id}`, "data-uat": `a-ev-list-${this.componentPrefix}-link` },
                this.renderEventsCount(this.props.event.aggregatedEventsCount, this.componentPrefix),
                this.renderCardDetails(this.props, this.componentPrefix),
                this.renderArrow(this.componentPrefix))));
    }
};
AggregateCard = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], AggregateCard);
export { AggregateCard };
//# sourceMappingURL=AggregateCard.js.map